import { Injectable } from '@angular/core';
import { ROWS_PER_PAGE_OPTIONS } from '@app/shared/common/constants';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import {
  SetPurchaseContractsDueForInvoicingListConfig,
  SetSalesContractsDueForInvoicingListConfig,
} from './_actions';
import { PurchaseContractType, SalesContractType } from '@app/infrastructure/api/models';

export const CURRENT_CONTRACTS_DUE_FOR_INVOICING_LIST_VERSION = 1;

export interface SalesContractsDueForInvoicingFilters {
  customerIds?: string[] | null;
  commodityIds?: string[] | null;
  types?: SalesContractType[] | null;
  fromDate?: string | null;
  toDate?: string | null;
  currencyIds?: number[] | null;
}

export interface PurchaseContractsDueForInvoicingFilters {
  supplierIds?: string[] | null;
  commodityIds?: string[] | null;
  types?: PurchaseContractType[] | null;
  fromDate?: string | null;
  toDate?: string | null;
  currencyIds?: number[] | null;
  isOutturn?: boolean | null;
}

interface ContractsDueForInvoicingStateModel {
  version: number;
  itemsPerPage: number;
  searchText?: string;
  salesFilters?: SalesContractsDueForInvoicingFilters;
  purchaseFilters?: PurchaseContractsDueForInvoicingFilters;
}

export const CONTRACTS_DUE_FOR_INVOICING_STATE_DEFAULTS: ContractsDueForInvoicingStateModel = {
  version: CURRENT_CONTRACTS_DUE_FOR_INVOICING_LIST_VERSION,
  itemsPerPage: ROWS_PER_PAGE_OPTIONS[0],
};

@State<ContractsDueForInvoicingStateModel>({
  name: 'ContractsDueForInvoicingList',
  defaults: CONTRACTS_DUE_FOR_INVOICING_STATE_DEFAULTS,
})
@Injectable()
export class ContractsDueForInvoicingListState {
  @Selector()
  static itemsPerPage(state: ContractsDueForInvoicingStateModel): number {
    return state.itemsPerPage;
  }

  @Selector()
  static searchText(state: ContractsDueForInvoicingStateModel): string | undefined {
    return state.searchText;
  }

  @Selector()
  static salesFilters(
    state: ContractsDueForInvoicingStateModel,
  ): SalesContractsDueForInvoicingFilters | undefined {
    return state.salesFilters;
  }

  @Selector()
  static purchaseFilters(
    state: ContractsDueForInvoicingStateModel,
  ): PurchaseContractsDueForInvoicingFilters | undefined {
    return state.purchaseFilters;
  }

  @Action(SetSalesContractsDueForInvoicingListConfig)
  setSalesListConfig(
    ctx: StateContext<ContractsDueForInvoicingStateModel>,
    action: SetSalesContractsDueForInvoicingListConfig,
  ) {
    const patch: Partial<ContractsDueForInvoicingStateModel> = {
      itemsPerPage: action.config.itemsPerPage,
      searchText: action.config.searchText,
      salesFilters: action.config.salesFilters,
    };

    ctx.patchState(patch);
  }

  @Action(SetPurchaseContractsDueForInvoicingListConfig)
  setPurchaseListConfig(
    ctx: StateContext<ContractsDueForInvoicingStateModel>,
    action: SetPurchaseContractsDueForInvoicingListConfig,
  ) {
    const patch: Partial<ContractsDueForInvoicingStateModel> = {
      itemsPerPage: action.config.itemsPerPage,
      searchText: action.config.searchText,
      purchaseFilters: action.config.purchaseFilters,
    };

    ctx.patchState(patch);
  }
}
